module.exports = __webpack_public_path__ + "img/error_img.cfdc17a1.svg";